"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageGalleryComponent = exports.ImageGalleryComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var Gallery_1 = require("Views/Partials/Components/Gallery/Gallery");
var ImageGalleryComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ImageGalleryComponent, _super);
    function ImageGalleryComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.image-gallery';
        return _this;
    }
    ImageGalleryComponent.prototype.OnInit = function () {
        var _this = this;
        this.el.forEach(function (el, index) {
            _this.renderMediaGallery(el, index);
        });
    };
    ImageGalleryComponent.prototype.renderMediaGallery = function (el, index) {
        (0, Gallery_1.RenderGallery)({
            galleryProperties: el.getAttribute('data-items'),
            uniqueClassName: "media-element-".concat(index),
            playButtonAriaLabel: el.getAttribute('data-play-button-aria-label'),
            popupAriaLabel: el.getAttribute('data-popup-aria-label'),
            closeButtonAriaLabel: el.getAttribute('data-close-button-aria-label'),
            hideThumbnails: this.checkIsHideThumbnails(el.getAttribute('data-hide-thumbnails')),
        }, el);
    };
    ImageGalleryComponent.prototype.checkIsHideThumbnails = function (attr) {
        return !attr ? false : attr.toLowerCase() === 'true';
    };
    return ImageGalleryComponent;
}(app_1.Component));
exports.ImageGalleryComponent = ImageGalleryComponent;
exports.imageGalleryComponent = new ImageGalleryComponent();
